var InfoBannerModule = /** @class */ (function () {
    function InfoBannerModule() {
    }
    return InfoBannerModule;
}());
export { InfoBannerModule };
